import React from 'react'

import Layout from '../components/Layout'
import Paper from '../components/Paper'
import SEO from '../components/Seo'

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import Typography from '../components/Typography'
import Carousel from '../components/Carousel'

import compStyles from '../pageComponents/home/home.module.scss'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  bannerImage: {
    overflow: 'hidden',
    position: 'relative',
    height: '100%',
    width: '320px'
  },
  textOnImage: {
    maxWidth: '60vw',
    color: '#ddd', 
    position: 'absolute', 
    bottom: '15%', 
    left: '10%',
  },
  '@media screen and (min-width: 599px)': {
    bannerImage: {
      width: '500px',
      height: '100%',
      maxHeight: 'calc(90vh - 64px)',
    },
    carouselItem: {
      display: 'flex',
      justifyContent: 'center'
    }
  }
})

const PicturesPage = (props) => {
  const classes = useStyles();
  const images = useStaticQuery(graphql`
    query {
      placeholderImage: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "services"}}) {
        edges{
          node{
            base
              childImageSharp {
                fluid(quality: 100, maxWidth: 500) {
                  ...GatsbyImageSharpFluid
                }
              }
          }
        }
      }
    }
  `)
  
  return (
  <Layout>
    <SEO title='ಸೇವೆಗಳು' />
    <Paper>
      <Typography variant="h2" className={compStyles.about__heading}>ಸೇವೆಗಳು</Typography>
      <Carousel
        autoPlay={true}
        indicators={true}
        navButtonsAlwaysVisible={true}
        interval={5000}
        timeout={1000}
      >
        {
          images.placeholderImage.edges.map( (banner, index) => {
            return (
              <div key={index} className={classes.carouselItem}>
                <Img
                  className={classes.bannerImage}
                  fluid={banner.node.childImageSharp.fluid} />
              </div>
            )
          })
        }
      </Carousel>
    </Paper>
  </Layout>
  )
}

export default PicturesPage
